import React, { useEffect,useState } from "react";
import SaleOff from "../../../Products/SaleOff";
import {RoundFloor} from '../../../../utils/format'
import { navigate } from 'gatsby';
import {actionCart} from '../../../../service/cartService';
import {checkWWishlist, deleteWishlist, createWishlist, addProductToWishlist} from '../../../../service/wishlistService';
import { toast } from "react-toastify";
import {FromatNumberVIE} from '../../../../utils/format';

import './item.css';
const ItemHotDeal = ({item, index})=>{
    const percen = +item?.price['discount']/item.price['raw']*100;
    const handleAddToCart=(item, uri)=>{
        if(!window.localStorage.getItem('key') || window.localStorage.getItem('key') === null || window.localStorage.getItem('key') === ''){
            window.location.href = '/dang-nhap.html';
        }
        if(item.sku.includes('C') === true){
            window.localStorage.setItem('typepage', 'product');
            navigate(uri);
        }else{
            let params = {
                items: [{
                    product: item.sku,
                    type: 'item',
                    action: 'add',
                    quantity: 1,
                    promo_code: item.promoCode?? "",
                    combo_code: item.combCode ?? '',
                    uudai: item.uuDai,
                    user_referral:  window.localStorage.getItem('userReferral'),
                    id_share:   window.localStorage.getItem('idShare')
            }]
            }
            try {
                actionCart(params, window.localStorage.getItem('key')).then((response)=>{
                    if(+response.status === 200 && response.message?.length > 0){
                    localStorage.removeItem("itemsCart");
                    localStorage.setItem('itemsCart', JSON.stringify(response['message']));
                    window.localStorage.setItem('reloadCart', true);
                    toast.success('Thêm vào giỏ hàng thành công.');
                    }
                });
            } catch (err) {
            console.log(err);
            }
        }
    }
      const handleRedirect=(uri)=>{
        if(uri !== '/undefined'){
            window.location.href = uri;
        }
      }
    return( 
        <li key={index} >
            <div className="col-4 img-item in-f" onClick={() => handleRedirect('/'+item.linksp?.replace('/',''))}>
                <div className="box-img">
                    <img src={item.thumbnail} alt={item.name}/>
                </div>
                {
                        item.labelPromo ? (
                            <img src={item.labelPromo['imageWeb']['mobileDefault']['url']} alt="icon-chinh-hang" className="position-absolute"
                            style={item.labelPromo['position']['bottom']?({
                                width:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['width'],
                                height:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['height'],
                                left:+ item.labelPromo['position']['left'],
                                bottom:+ (+item.labelPromo['position']['bottom']),
                                zIndex:1, position:"absolute"
                        }):({
                            width:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['width'],
                            height:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['height'],
                            left:+ item.labelPromo['position']['left'],
                            top:+ item.labelPromo['position']['top'],
                            zIndex:1, position:"absolute"
                    })
                                
                            }/>
                        ):(null)
                    }
            </div>
            <div className="col-8 mgt-5">
                <div className="col-12 box-name-item d-flex mgt-10" onClick={() => handleRedirect('/'+item.linksp?.replace('/',''))}>
                    <span className="name-item">
                        {
                        item?.name?.length > 80 ? ( (item?.name).substring(0, 80) +'...') :(item?.name)
                        }
                        </span>
                </div>
                <div className="col-12 d-flex mgt-15">
                    <span className="price-sale">
                    {
                        +item?.price['discount'] < +item?.price['raw'] ? (
                            FromatNumberVIE(item?.price['raw'])
                        ) : (null)
                    }đ
                        </span>
                </div>
                <div className="item-sale">
                    <span className="price-now">
                    {
                        +item?.price['raw'] > +item?.price['discount'] ? (
                            FromatNumberVIE(item?.price['discount'])
                        ) : (null)
                    }đ
                    </span>
                    <div className="box-price-percent in-f">
                        <span className="price-percent">-
                        {
                            +item.price['discount'] !== +item.price['raw'] ? (<SaleOff key={index}
                                percen={RoundFloor(100-percen)} />) : (null)
                        }
                        </span>
                    </div>
                </div>
                <div className="row mgt-5 mgx-0">
                    <div className="col-10 nav-available pdx-0 pdr-5">
                        <div className="available-item">
                            <span className="color_width" data-title="0" data-toggle="tooltip" style={{"width":+item.hotdeal?.total > +item.hotdeal?.quantity ?((+item.hotdeal?.quantity/+item.hotdeal?.total)*100-5):(0)}} data-original-title="" title=""></span>
                        </div>
                        <img className="image-animation" src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/Vector.png" alt="icon" style={{"left": +item.hotdeal?.total > +item.hotdeal?.quantity ?((+item.hotdeal?.quantity/+item.hotdeal?.total)*100-5):(0) }}/>
                        <span className="available-text">Còn {+item.hotdeal?.quantity} sản phẩm</span>
                    </div>
                    <div className="col-2 pdl-10"> 
                        <img className="svg-addcart" onClick={()=>handleAddToCart(item, '/'+item.linksp?.replace('/',''))} src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/ic_addcart.png" alt="icon"/>
                    </div>
                </div>
            </div>
        </li>
    )
}

const ItemHotDealLanding = ({item, index})=>{
    if(item.typePromotion &&  +item.typePromotion  !== 1 && item.parent){
        item.linksp = item.parent.linksp;
    }
    const percen = +item?.price['discount']/item.price['raw']*100;
    const handleAddToCart=(item, uri)=>{
        if(!window.localStorage.getItem('key') || window.localStorage.getItem('key') === null || window.localStorage.getItem('key') === ''){
            window.location.href = '/dang-nhap.html';
        }
        if(item.sku.includes('C') === true || +item.typePromotion === 3){
            window.localStorage.setItem('typepage', 'product');
            window.location.href = uri;
        }else{
            let params = {
                items: [{
                    product: item.sku,
                    type: 'item',
                    action: 'add',
                    quantity: 1,
                    promo_code: item.promoCode?? "",
                    combo_code: item.combCode ?? '',
                    uudai: item.uuDai,
                    user_referral:  window.localStorage.getItem('userReferral'),
                    id_share:   window.localStorage.getItem('idShare')
            }]
            }
            try {
                actionCart(params, window.localStorage.getItem('key')).then((response)=>{
                    if(+response.status === 200 && response.message?.length > 0){
                    localStorage.removeItem("itemsCart");
                    localStorage.setItem('itemsCart', JSON.stringify(response['message']));
                    window.localStorage.setItem('reloadCart', true);
                    toast.success('Thêm vào giỏ hàng thành công.');
                    }
                });
            } catch (err) {
            console.log(err);
            }
        }
    }
      const handleRedirect=(uri)=>{
        if(uri !== '/undefined'){
            window.location.href = uri;
        }
      }
    return( 
        <React.Fragment>
        <li key={index+item.sku} >
            <div className="box-detail">
                    <div className="col-12 img-item in-f" >
                        <div className="box-img-resize">
                            <img onClick={() => handleRedirect('/'+item.linksp?.replace('/',''))} key="size-img" className="size-img" src={item.thumbnail} alt={item.name}/>
                            {
                            +item?.price['discount'] < +item?.price['raw'] ?(<div className="box-sale-percent"><span>-{RoundFloor(100-percen)}%</span></div>):(null)
                            }
                        </div>

                        {
                        item.labelPromo ? (
                            <img src={item.labelPromo['imageWeb']['mobileDefault']['url']} alt="icon-chinh-hang" className="position-absolute"
                            style={item.labelPromo['position']['bottom']?({
                                width:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['width'],
                                height:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['height'],
                                left:+ item.labelPromo['position']['left'],
                                bottom:+ (+item.labelPromo['position']['bottom']),
                                zIndex:1, position:"absolute"
                        }):({
                            width:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['width'],
                            height:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['height'],
                            left:+ item.labelPromo['position']['left'],
                            top:+ item.labelPromo['position']['top'],
                            zIndex:1, position:"absolute"
                    })
                                
                            }/>
                        ):(null)
                    }
                    </div>
                    <div className="col-12 box-name-item pdx-8 d-flex" onClick={() => handleRedirect('/'+item.linksp?.replace('/',''))}>
                        <span className="name-item">{
                        item?.name?.length > 40 ? ( (item?.name).substring(0, 40) +'...') :(item?.name)
                        }</span>
                    </div>
                    <div className="col-12 mgt-5 pdx-8">
                    {
                        +item?.price['discount'] < +item?.price['raw'] ? (
                            <>
                                <span className="price-item pdr-5">{
                                    FromatNumberVIE(item?.price['discount'])
                                }đ</span>
                                <span className="price-sale">{
                                    FromatNumberVIE(item?.price['raw'])
                                }đ</span>
                            </>
                            
                        ) : (<span className="price-item ">{
                            FromatNumberVIE(item?.price['raw'])
                        }đ</span>)
                    }
                    </div>
                <div className="col-12 in-f mgt-5 mgb-5 pdx-8">
                    <div className="col-10 nav-available pdx-0 pdr-5">
                        <div className="available-item">
                            <span className="color_width" data-title="0" data-toggle="tooltip" style={{"width":+item.hotdeal?.total > +item.hotdeal?.quantity ?((+item.hotdeal?.quantity/+item.hotdeal?.total)*100-5):(0)}} data-original-title="" title=""></span>
                        </div>
                        <img className="image-animation" src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/Vector.png" alt="icon" style={{"left": +item.hotdeal?.total > +item.hotdeal?.quantity ?((+item.hotdeal?.quantity/+item.hotdeal?.total)*100-5):(0) }}/>
                        <span className="available-text">Còn {+item.hotdeal?.quantity} sản phẩm</span>
                    </div>
                    <div className="col-2 in-f">
                        <img className="svg-addcart" onClick={()=>handleAddToCart(item, '/'+item.linksp?.replace('/',''))} src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/ic_addcart.png" alt="icon"/>
                    </div>
                </div>
            </div>
        </li>
        </React.Fragment>
    )
}

const ItemProductGift = ({item, index})=>{
    if(item.typePromotion &&  +item.typePromotion  !== 1 && item.parent){
        item.linksp = item.parent.linksp;
    }
    const percen = +item?.price['discount']/item.price['raw']*100;
    const handleAddToCart=(item, uri)=>{
        if(!window.localStorage.getItem('key') || window.localStorage.getItem('key') === null || window.localStorage.getItem('key') === ''){
            window.location.href = '/dang-nhap.html';
        }
        if(item.sku.includes('C') === true || +item.typePromotion === 3){
            window.localStorage.setItem('typepage', 'product');
            window.location.href = uri;
        }else{
            let params = {
                items: [{
                    product: item.sku,
                    type: 'item',
                    action: 'add',
                    quantity: 1,
                    promo_code: item.promoCode?? "",
                    combo_code: item.combCode ?? '',
                    uudai: item.uuDai,
                    user_referral:  window.localStorage.getItem('userReferral'),
                    id_share:   window.localStorage.getItem('idShare')
            }]
            }
            try {
                actionCart(params, window.localStorage.getItem('key')).then((response)=>{
                    if(+response.status === 200 && response.message?.length > 0){
                    localStorage.removeItem("itemsCart");
                    localStorage.setItem('itemsCart', JSON.stringify(response['message']));
                    window.localStorage.setItem('reloadCart', true);
                    toast.success('Thêm vào giỏ hàng thành công.');
                    }
                });
            } catch (err) {
            console.log(err);
            }
        }
    }
    const handleRedirect=(uri)=>{
        if(uri !== '/undefined'){
            window.location.href = uri;
        }
      }
      const [wishlist, setWishlist] = useState(false);
      const handleWishlist=(sku, isFavorite)=>{
          console.log(sku);
          console.log(isFavorite);
          if(window.localStorage.getItem('key')){
              setWishlist(!wishlist);
              checkWWishlist(window.localStorage.getItem('_id'),window.localStorage.getItem('_id'),sku).then((response)=>{
                  console.log(response);
              })
  
              if(isFavorite){
                  deleteWishlist(window.localStorage.getItem('_id'),window.localStorage.getItem('_id'),sku).then((response)=>{
                      console.log(response);
                  })
              }else{
                  let param = {
                      "code": window.localStorage.getItem('_id'),
                      "user_id": window.localStorage.getItem('_id'),
                      "name": "danh-sach-yeu-thich",
                      "source": "cusapp",
                      "type": "",
                    };
                  createWishlist(param).then((response)=>{
                      if(+response.status === 200){
                         let data = {
                              "wishlist_id": window.localStorage.getItem('_id'),
                              "user_id": window.localStorage.getItem('_id'),
                              "product_id": sku,
                            };
                            addProductToWishlist(data).then((response)=>{
                              console.log(response);
                            })
                      }
                  })
              }  
          }
      }
    return( 
        <li key={index} >
            <div className="box-detail">
                <div className="col-12 img-item in-f" >
                    <div className="box-img-resize">
                        <img onClick={() => handleRedirect('/'+item.linksp?.replace('/',''))} className="size-img" src={item.thumbnail} alt={item.name}/>
                        <img onClick={()=>handleWishlist(item.sku, item.isFavorite)} className="img-like"  src={ wishlist || item.isFavorite ? ("/../images/web_app/ic_like_active.svg"):("https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/ic_like.png")} alt="icon"/>
                        {
                        +item?.price['discount'] !== +item?.price['raw'] ?(<div className="box-sale-percent"><span>{RoundFloor(100-percen)}%</span></div>):(null)
                        }
                    </div>
                    {
                        item.labelPromo ? (
                            <img src={item.labelPromo['imageWeb']['mobileDefault']['url']} alt="icon-chinh-hang" className="position-absolute"
                            style={item.labelPromo['position']['bottom']?({
                                width:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['width'],
                                height:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['height'],
                                left:+ item.labelPromo['position']['left'],
                                bottom:+ (+item.labelPromo['position']['bottom']),
                                zIndex:1, position:"absolute"
                        }):({
                            width:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['width'],
                            height:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['height'],
                            left:+ item.labelPromo['position']['left'],
                            top:+ item.labelPromo['position']['top'],
                            zIndex:1, position:"absolute"
                    })
                                
                            }/>
                        ):(null)
                    }
                </div>
                <div className="col-12 box-name-item pdx-8 d-flex" onClick={() => handleRedirect('/'+item.linksp?.replace('/',''))}>
                    <span className="name-item">{
                    item?.name?.length > 40 ? ( (item?.name).substring(0, 40) +'...') :(item?.name)
                    }</span>
                </div>
                <div className="col-12 mgt-5 pdx-8">
                    <span className="price-item">
                        {
                            +item?.price['discount'] < +item?.price['raw'] ? (
                                FromatNumberVIE(item?.price['raw'])
                            ) : (FromatNumberVIE(item?.price['discount']))
                        }đ</span>
                </div>
                <div className="col-12 in-f mgt-5 mgb-5 pdx-8">
                    <div className="col-10 box-list box-item-sale-bg mgr-5">
                        <span>Mua là có Quà</span>
                    </div>
                    <div className="col-2 in-f">
                        <img className="svg-addcart" onClick={()=>handleAddToCart(item, '/'+item.linksp?.replace('/',''))} src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/ic_addcart.png"/>
                    </div>
                </div>
            </div>
        </li>
    )
}
const ItemProductGiftList = ({item, index})=>{
    if(item.typePromotion &&  +item.typePromotion  !== 1 && item.parent){
        item.linksp = item.parent.linksp;
    }
    const percen = +item?.price['discount']/item.price['raw']*100;
    const handleAddToCart=(item, uri)=>{
        if(!window.localStorage.getItem('key') || window.localStorage.getItem('key') === null || window.localStorage.getItem('key') === ''){
            window.location.href = '/dang-nhap.html';
        }
        if(item.sku.includes('C') === true || +item.typePromotion === 3){
            window.localStorage.setItem('typepage', 'product');
            window.location.href = uri;
        }else{
            let params = {
                items: [{
                    product: item.sku,
                    type: 'item',
                    action: 'add',
                    quantity: 1,
                    promo_code: item.promoCode?? "",
                    combo_code: item.combCode ?? '',
                    uudai: item.uuDai,
                    user_referral:  window.localStorage.getItem('userReferral'),
                    id_share:   window.localStorage.getItem('idShare')
            }]
            }
            try {
                actionCart(params, window.localStorage.getItem('key')).then((response)=>{
                    if(+response.status === 200 && response.message?.length > 0){
                    localStorage.removeItem("itemsCart");
                    localStorage.setItem('itemsCart', JSON.stringify(response['message']));
                    window.localStorage.setItem('reloadCart', true);
                    toast.success('Thêm vào giỏ hàng thành công.');
                    }
                });
            } catch (err) {
            console.log(err);
            }
        }
    }
    const handleRedirect=(uri)=>{
        if(uri !== '/undefined'){
            window.location.href = uri;
        }
      }
    return( 
        <li key={item.sku+index} >
            <div className="col-5 img-item in-f">
                <div className="col-7" onClick={() => handleRedirect('/'+item.linksp?.replace('/',''))}>
                    <img className="size-img-list-item-gift" src={item.thumbnail} alt={item.name}/>
                    {
                     +item?.price['discount'] !== +item?.price['raw'] ?(<div className="box-sale-percent"><span>{RoundFloor(100-percen)}%</span></div>):(null)
                    }
                </div>
                <div className="col-5">
                    <div className="item-gift">
                        <div className="text-gift">
                            <span>tặng</span>
                        </div>
                        <div className="">
                            <img className="img-gift-mobile" src={item.thumbnail_gifts[0]} alt={item.name}/>
                        </div>
                    </div>
                </div>
                {
                        item.labelPromo ? (
                            <img src={item.labelPromo['imageWeb']['mobileDefault']['url']} alt="icon-chinh-hang" className="position-absolute"
                            style={item.labelPromo['position']['bottom']?({
                                width:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['width'],
                                height:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['height'],
                                left:+ item.labelPromo['position']['left'],
                                bottom:+ (+item.labelPromo['position']['bottom']),
                                zIndex:1, position:"absolute"
                        }):({
                            width:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['width'],
                            height:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['height'],
                            left:+ item.labelPromo['position']['left'],
                            top:+ item.labelPromo['position']['top'],
                            zIndex:1, position:"absolute"
                    })
                                
                            }/>
                        ):(null)
                    }
            </div>
            <div className="col-7 pdl-10">
                <div className="col-12 box-name-item d-flex" onClick={() => handleRedirect('/'+item.linksp?.replace('/',''))}>
                    <span className="name-item">
                    {
                    item?.name?.length > 50 ? ( (item?.name).substring(0, 50) +'...') :(item?.name)
                    }
                        </span>       
                </div>
                <div className="col-12 item-sale mgt-10">
                    <span className="price-now"> {
                                +item?.price['discount'] < +item?.price['raw'] ? (
                                    FromatNumberVIE(item?.price['raw'])
                                ) : (FromatNumberVIE(item?.price['discount']))
                            }đ</span>
                </div>
                <div className="col-12 in-f mgt-10 pdr-10">
                    <div className="col-12 box-list box-item-sale-none-bg-red-black">
                        <span>Mua là có Quà</span>
                    </div>
                </div>
            </div>
        </li>
    )
}

const Item = ({item, index})=>{
    if(item.typePromotion &&  +item.typePromotion  !== 1 && item.parent){
        item.linksp = item.parent.linksp;
    }
    const percen = +item?.price['discount']/item.price['raw']*100;
    const handleAddToCart=(item, uri)=>{
        if(!window.localStorage.getItem('key') || window.localStorage.getItem('key') === null || window.localStorage.getItem('key') === ''){
            window.location.href = '/dang-nhap.html';
        }
        if(item.sku.includes('C') === true || +item.typePromotion === 3){
            window.localStorage.setItem('typepage', 'product');
            window.location.href = uri;
        }else{
            let params = {
                items: [{
                    product: item.sku,
                    type: 'item',
                    action: 'add',
                    quantity: 1,
                    promo_code: item.promoCode?? "",
                    combo_code: item.combCode ?? '',
                    uudai: item.uuDai,
                    user_referral:  window.localStorage.getItem('userReferral'),
                    id_share:   window.localStorage.getItem('idShare')
            }]
            }
            try {
                actionCart(params, window.localStorage.getItem('key')).then((response)=>{
                    if(+response.status === 200 && response.message?.length > 0){
                    localStorage.removeItem("itemsCart");
                    localStorage.setItem('itemsCart', JSON.stringify(response['message']));
                    window.localStorage.setItem('reloadCart', true);
                    toast.success('Thêm vào giỏ hàng thành công.');
                    }
                });
            } catch (err) {
            console.log(err);
            }
        }
    }
    const handleRedirect=(uri)=>{
        if(uri !== '/undefined'){
            window.location.href = uri;
        }
      }
      const [wishlist, setWishlist] = useState(false);
        const handleWishlist=(sku, isFavorite)=>{
            if(window.localStorage.getItem('key')){
                setWishlist(!wishlist);
                checkWWishlist(window.localStorage.getItem('_id'),window.localStorage.getItem('_id'),sku).then((response)=>{
                    console.log(response);
                })

                if(isFavorite){
                    deleteWishlist(window.localStorage.getItem('_id'),window.localStorage.getItem('_id'),sku).then((response)=>{
                        console.log(response);
                    })
                }else{
                    let param = {
                        "code": window.localStorage.getItem('_id'),
                        "user_id": window.localStorage.getItem('_id'),
                        "name": "danh-sach-yeu-thich",
                        "source": "cusapp",
                        "type": "",
                    };
                    createWishlist(param).then((response)=>{
                        if(+response.status === 200){
                        let data = {
                                "wishlist_id": window.localStorage.getItem('_id'),
                                "user_id": window.localStorage.getItem('_id'),
                                "product_id": sku,
                            };
                            addProductToWishlist(data).then((response)=>{
                                console.log(response);
                            })
                        }
                    })
                }  
            }
        }
    return( 
        <React.Fragment>
        <li key={index+item.sku} >
            <div className="box-detail">
                <div className="col-12 img-item in-f" >
                    <div className="box-img-resize">
                    <img onClick={() => handleRedirect('/'+item.linksp?.replace('/',''))} key="size-img" className="size-img" src={item.thumbnail.replace('/origin', '/thumb')} alt={item.name}/>
                    <img onClick={()=>handleWishlist(item.sku, item.isFavorite)} className="img-like"  src={ wishlist || item.isFavorite ? ("/../images/web_app/ic_like_active.svg"):("https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/ic_like.png")} alt="icon"/>
                    {
                     +item?.price['discount'] < +item?.price['raw'] ?(<div className="box-sale-percent"><span>-{RoundFloor(100-percen)}%</span></div>):(null)
                    }
                    </div>
                    {
                        item.labelPromo ? (
                            <img src={item.labelPromo['imageWeb']['mobileDefault']['url']} alt="icon-chinh-hang" className="position-absolute"
                            style={item.labelPromo['position']['bottom']?({
                                width:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['width'],
                                height:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['height'],
                                left:+ item.labelPromo['position']['left'],
                                bottom:+ (+item.labelPromo['position']['bottom']),
                                zIndex:1, position:"absolute"
                        }):({
                            width:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['width'],
                            height:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['height'],
                            left:+ item.labelPromo['position']['left'],
                            top:+ item.labelPromo['position']['top'],
                            zIndex:1, position:"absolute"
                    })
                                
                            }/>
                        ):(null)
                    }
                </div>
                <div className="col-12 box-name-item pdx-8 d-flex" onClick={() => handleRedirect('/'+item.linksp?.replace('/',''))}>
                    <span className="name-item">{
                    item?.name?.length > 40 ? ( (item?.name).substring(0, 40) +'...') :(item?.name)
                    }</span>
                </div>
                <div className="col-12 mgt-5 pdx-8">
                {
                    +item?.price['discount'] < +item?.price['raw'] ? (
                        <>
                            <span className="price-item pdr-5">{
                                FromatNumberVIE(item?.price['discount'])
                            }đ</span>
                            <span className="price-sale">{
                                FromatNumberVIE(item?.price['raw'])
                            }đ</span>
                        </>
                        
                    ) : (<span className="price-item ">{
                        FromatNumberVIE(item?.price['raw'])
                    }đ</span>)
                }
                </div>
                <div className="col-12 in-f mgt-5 mgb-5 pdx-8">
                    <div className="col-10 mgr-5">

                        {
                            item.typePromotion   && item.typePromotion !== 'Mua là có quà' ? (

                                (() => { switch(+item.typePromotion){
                                    case 3:
                                        return <div className="box-list box-item-sale-bg">
                                                {
                                                    item.namePromotion?.length > 0 ? (
                                                        <span>{item.namePromotion}</span>
                                                    ):(null)
                                                }
                                            </div>
                                    case 4:
                                        return <div className="box-list box-item-sale-none-bg-border-origin">
                                            {
                                                item.namePromotion?.length > 0 ? (
                                                    <span>{item.namePromotion}</span>
                                                ):(null)
                                            }
                                        </div>
                                    case 6:
                                        return <div className="box-list box-item-sale-none-bg-border-red">
                                                {
                                                    item.namePromotion?.length > 0 ? (
                                                        <span>{item.namePromotion}</span>
                                                    ):(null)
                                                }
                                            </div>
                                    default:
                                        return <div className="box-list box-item-sale-bg">
                                            {
                                                item.namePromotion?.length > 0 ? (
                                                    <span>{item.namePromotion}</span>
                                                ):(null)
                                            }
                                        </div>
                                    }
                                })()

                            ):(null)
                        }
                        {
                            +item.bixu > 0 ? (
                                <div className="box-list box-item-sale-none-bg-border-origin">
                                    <span>+{FromatNumberVIE(+item.bixu)} Bixu</span>
                                </div>
                            ):(null)
                        }
                    </div>
                    <div className="col-2 in-f">
                        <img className="svg-addcart" onClick={()=>handleAddToCart(item, '/'+item.linksp?.replace('/',''))} src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/ic_addcart.png" alt="icon"/>
                    </div>
                </div>
            </div>
        </li>
        </React.Fragment>
    )
}

const ItemDefault = ({item, index})=>{
    if(item.typePromotion &&  +item.typePromotion  !== 1 && item.parent){
        item.linksp = item.parent.linksp;
    }
    const handleRedirect=(uri)=>{
        if(uri !== '/undefined'){
            window.location.href = uri;
        }
      }
      useEffect(()=>{
      },[item])
    return( 
        <>
            <div className="row pd-5 mgx-0" key={index+item.sku} onClick={() => handleRedirect('/'+item.linksp?.replace('/',''))}>
                <div className="col-12 img-item box-img in-f">
                    <img  src={item.thumbnail} alt={item.name}/>
                    {
                        item.labelPromo ? (
                            <img src={item.labelPromo['imageWeb']['mobileDefault']['url']} alt="icon-chinh-hang" className="position-absolute"
                            style={item.labelPromo['position']['bottom']?({
                                width:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['width'],
                                height:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['height'],
                                left:+ item.labelPromo['position']['left'],
                                bottom:+ (+item.labelPromo['position']['bottom']),
                                zIndex:1, position:"absolute"
                        }):({
                            width:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['width'],
                            height:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['height'],
                            left:+ item.labelPromo['position']['left'],
                            top:+ item.labelPromo['position']['top'],
                            zIndex:1, position:"absolute"
                    })
                                
                            }/>
                        ):(null)
                    }
                </div>
                
                <div className="col-12 mgt-5 pdx-8">
                    <div className="d-flex">
                        <span className="name-similar">
                        {
                        item?.name?.length > 22 ? ( (item?.name).substring(0, 22) +'...') :(item?.name)
                        }</span>
                    </div>
                    <span className="price-similar">
                    {
                        +item?.price['discount'] < +item?.price['raw'] ? (FromatNumberVIE(item?.price['discount'])) : (FromatNumberVIE(item?.price['raw']))
                    }
                        đ</span>
                </div>
                <div className="col-12 in-f mgt-5 mgb-5 pdx-8">
                    <div className="col-1 in-f">
                    </div>
                    {
                        item.namePromotion?.length > 0 ? (
                            <div className="col-9 box-list box-item-sale-bg">
                                <span>{item.namePromotion}</span>
                            </div>
                        ):(null)
                    }
                    <div className="col-2 in-f">
                    </div>
                </div>
            </div>
        </>
    )
}
// using slide

const ItemUsingSlide = ({item, index})=>{
    if(item.typePromotion &&  +item.typePromotion  !== 1 && item.parent){
        item.linksp = item.parent.linksp;
    }
    const percen = +item?.price['discount']/item.price['raw']*100;
    const handleAddToCart=(item, uri)=>{
        if(!window.localStorage.getItem('key') || window.localStorage.getItem('key') === null || window.localStorage.getItem('key') === ''){
            window.location.href = '/dang-nhap.html';
        }
        if(item.sku.includes('C') === true || +item.typePromotion === 3){
            window.localStorage.setItem('typepage', 'product');
            window.location.href = uri;
        }else{
            let params = {
                items: [{
                    product: item.sku,
                    type: 'item',
                    action: 'add',
                    quantity: 1,
                    promo_code: item.promoCode?? "",
                    combo_code: item.combCode ?? '',
                    uudai: item.uuDai,
                    user_referral:  window.localStorage.getItem('userReferral'),
                    id_share:   window.localStorage.getItem('idShare')
            }]
            }
            try {
                actionCart(params, window.localStorage.getItem('key')).then((response)=>{
                    if(+response.status === 200 && response.message?.length > 0){
                    localStorage.removeItem("itemsCart");
                    localStorage.setItem('itemsCart', JSON.stringify(response['message']));
                    window.localStorage.setItem('reloadCart', true);
                    toast.success('Thêm vào giỏ hàng thành công.');
                    }
                });
            } catch (err) {
            console.log(err);
            }
        }
    }
    const handleRedirect=(uri)=>{
        if(uri !== '/undefined'){
            window.location.href = uri;
        }
      }
      const [wishlist, setWishlist] = useState(false);
        const handleWishlist=(sku, isFavorite)=>{
            if(window.localStorage.getItem('key')){
                setWishlist(!wishlist);
                checkWWishlist(window.localStorage.getItem('_id'),window.localStorage.getItem('_id'),sku).then((response)=>{
                    console.log(response);
                })

                if(isFavorite){
                    deleteWishlist(window.localStorage.getItem('_id'),window.localStorage.getItem('_id'),sku).then((response)=>{
                        console.log(response);
                    })
                }else{
                    let param = {
                        "code": window.localStorage.getItem('_id'),
                        "user_id": window.localStorage.getItem('_id'),
                        "name": "danh-sach-yeu-thich",
                        "source": "cusapp",
                        "type": "",
                    };
                    createWishlist(param).then((response)=>{
                        if(+response.status === 200){
                        let data = {
                                "wishlist_id": window.localStorage.getItem('_id'),
                                "user_id": window.localStorage.getItem('_id'),
                                "product_id": sku,
                            };
                            addProductToWishlist(data).then((response)=>{
                                console.log(response);
                            })
                        }
                    })
                }  
            }
        }
    return( 
        <React.Fragment>
            <div className="box-detail" key={index+item.sku}>
                <div className="col-12 img-item in-f" >
                    <div className="box-img-resize">
                    <img onClick={() => handleRedirect('/'+item.linksp?.replace('/',''))} key="size-img" className="size-img" src={item.thumbnail.replace('/origin', '/thumb')} alt={item.name}/>
                    <img onClick={()=>handleWishlist(item.sku, item.isFavorite)} className="img-like"  src={ wishlist || item.isFavorite ? ("/../images/web_app/ic_like_active.svg"):("https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/ic_like.png")} alt="icon"/>
                    {
                     +item?.price['discount'] < +item?.price['raw'] ?(<div className="box-sale-percent"><span>-{RoundFloor(100-percen)}%</span></div>):(null)
                    }
                    </div>
                    {
                        item.labelPromo ? (
                            <img src={item.labelPromo['imageWeb']['mobileDefault']['url']} alt="icon-chinh-hang" className="position-absolute"
                            style={item.labelPromo['position']['bottom']?({
                                width:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['width'],
                                height:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['height'],
                                left:+ item.labelPromo['position']['left'],
                                bottom:+ (+item.labelPromo['position']['bottom']),
                                zIndex:1, position:"absolute"
                        }):({
                            width:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['width'],
                            height:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['height'],
                            left:+ item.labelPromo['position']['left'],
                            top:+ item.labelPromo['position']['top'],
                            zIndex:1, position:"absolute"
                    })
                                
                            }/>
                        ):(null)
                    }
                </div>
                <div className="col-12 box-name-item pdx-8 d-flex" onClick={() => handleRedirect('/'+item.linksp?.replace('/',''))}>
                    <span className="name-item">{
                    item?.name?.length > 40 ? ( (item?.name).substring(0, 40) +'...') :(item?.name)
                    }</span>
                </div>
                <div className="col-12 mgt-5 pdx-8">
                {
                    +item?.price['discount'] < +item?.price['raw'] ? (
                        <>
                            <span className="price-item pdr-5">{
                                FromatNumberVIE(item?.price['discount'])
                            }đ</span>
                            <span className="price-sale">{
                                FromatNumberVIE(item?.price['raw'])
                            }đ</span>
                        </>
                        
                    ) : (<span className="price-item ">{
                        FromatNumberVIE(item?.price['raw'])
                    }đ</span>)
                }
                </div>
                <div className="col-12 in-f mgt-5 mgb-5 pdx-8">
                    <div className="col-10 mgr-5">

                        {
                            item.typePromotion  && item?.namePromotion !== '' ? (

                                (() => { switch(+item.typePromotion){
                                    case 3:
                                        return <div className="box-list box-item-sale-bg">
                                                {
                                                    item.namePromotion?.length > 0 ? (
                                                        <span>{item.namePromotion}</span>
                                                    ):(null)
                                                }
                                            </div>
                                    case 4:
                                        return <div className="box-list box-item-sale-none-bg-border-origin">
                                            {
                                                item.namePromotion?.length > 0 ? (
                                                    <span>{item.namePromotion}</span>
                                                ):(null)
                                            }
                                        </div>
                                    case 6:
                                        return <div className="box-list box-item-sale-none-bg-border-red">
                                                {
                                                    item.namePromotion?.length > 0 ? (
                                                        <span>{item.namePromotion}</span>
                                                    ):(null)
                                                }
                                            </div>
                                    default:
                                        return <div className="box-list box-item-sale-bg">
                                            {
                                                item.namePromotion?.length > 0 ? (
                                                    <span>{item.namePromotion}</span>
                                                ):(null)
                                            }
                                        </div>
                                    }
                                })()

                            ):(null)
                        }
                        {
                            +item.bixu > 0 ? (
                                <div className="box-list box-item-sale-none-bg-border-origin">
                                    <span>+{FromatNumberVIE(+item.bixu)} Bixu</span>
                                </div>
                            ):(null)
                        }
                    </div>
                    <div className="col-2 in-f">
                        <img className="svg-addcart" onClick={()=>handleAddToCart(item, '/'+item.linksp?.replace('/',''))} src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/ic_addcart.png" alt="icon"/>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}
const ItemHotDealLandingUsingSlide = ({item, index})=>{
    const percen = +item?.price['discount']/item.price['raw']*100;
    const handleAddToCart=(item, uri)=>{
        if(!window.localStorage.getItem('key') || window.localStorage.getItem('key') === null || window.localStorage.getItem('key') === ''){
            window.location.href = '/dang-nhap.html';
        }
        if(item.sku.includes('C') === true || +item.typePromotion === 3){
            window.localStorage.setItem('typepage', 'product');
            window.location.href = uri;
        }else{
            let params = {
                items: [{
                    product: item.sku,
                    type: 'item',
                    action: 'add',
                    quantity: 1,
                    promo_code: item.promoCode?? "",
                    combo_code: item.combCode ?? '',
                    uudai: item.uuDai,
                    user_referral:  window.localStorage.getItem('userReferral'),
                    id_share:   window.localStorage.getItem('idShare')
            }]
            }
            try {
                actionCart(params, window.localStorage.getItem('key')).then((response)=>{
                    if(+response.status === 200 && response.message?.length > 0){
                    localStorage.removeItem("itemsCart");
                    localStorage.setItem('itemsCart', JSON.stringify(response['message']));
                    window.localStorage.setItem('reloadCart', true);
                    toast.success('Thêm vào giỏ hàng thành công.');
                    }
                });
            } catch (err) {
            console.log(err);
            }
        }
    }
      const handleRedirect=(uri)=>{
        if(uri !== '/undefined'){
            window.location.href = uri;
        }
      }
    return( 
        <React.Fragment>
            <div className="box-detail" key={index+item.sku}>
                <div className="col-12 img-item in-f" >
                    <div className="box-img-resize">
                        <img onClick={() => handleRedirect('/'+item.linksp?.replace('/',''))} key="size-img" className="size-img" src={item.thumbnail.replace('/origin', '/thumb')} alt={item.name}/>
                        {
                        +item?.price['discount'] < +item?.price['raw'] ?(<div className="box-sale-percent"><span>-{RoundFloor(100-percen)}%</span></div>):(null)
                        }
                        </div>

                        {
                        item.labelPromo ? (
                            <img src={item.labelPromo['imageWeb']['mobileDefault']['url']} alt="icon-chinh-hang" className="position-absolute"
                            style={item.labelPromo['position']['bottom']?({
                                width:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['width'],
                                height:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['height'],
                                left:+ item.labelPromo['position']['left'],
                                bottom:+ (+item.labelPromo['position']['bottom']),
                                zIndex:1, position:"absolute"
                        }):({
                            width:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['width'],
                            height:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['height'],
                            left:+ item.labelPromo['position']['left'],
                            top:+ item.labelPromo['position']['top'],
                            zIndex:1, position:"absolute"
                    })
                                
                            }/>
                        ):(null)
                    }
                    </div>
                    <div className="col-12 box-name-item pdx-8 d-flex" onClick={() => handleRedirect('/'+item.linksp?.replace('/',''))}>
                        <span className="name-item">{
                        item?.name?.length > 40 ? ( (item?.name).substring(0, 40) +'...') :(item?.name)
                        }</span>
                    </div>
                <div className="col-12 mgt-5 pdx-8">
                {
                    +item?.price['discount'] < +item?.price['raw'] ? (
                        <>
                            <span className="price-item pdr-5">{
                                FromatNumberVIE(item?.price['discount'])
                            }đ</span>
                            <span className="price-sale">{
                                FromatNumberVIE(item?.price['raw'])
                            }đ</span>
                        </>
                        
                    ) : (<span className="price-item ">{
                        FromatNumberVIE(item?.price['raw'])
                    }đ</span>)
                }
                </div>
                <div className="col-12 in-f mgt-5 mgb-5 pdx-8">
                <div className="col-10 nav-available pdx-0 pdr-5">
                        <div className="available-item">
                            <span className="color_width" data-title="0" data-toggle="tooltip" style={{"width":+item.hotdeal?.total > 0 ? ((+item.hotdeal?.quantity/+item.hotdeal?.total)*50-5):(0)}} data-original-title="" title=""></span>
                        </div>
                        <img className="image-animation" src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/Vector.png" alt="icon" style={{"left": +item.hotdeal?.total > 0 ?((+item.hotdeal?.quantity/+item.hotdeal?.total)*50-5):(0) }}/>
                        <span className="available-text">Còn {+item.hotdeal?.quantity} sản phẩm</span>
                    </div>
                    <div className="col-2 in-f">
                        <img className="svg-addcart" onClick={()=>handleAddToCart(item, '/'+item.linksp?.replace('/',''))} src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/ic_addcart.png" alt="icon"/>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}
const ItemProductGiftUsingSlide = ({item, index})=>{
    if(item.typePromotion &&  +item.typePromotion  !== 1 && item.parent){
        item.linksp = item.parent.linksp;
    }
    const percen = +item?.price['discount']/item.price['raw']*100;
    const handleAddToCart=(item, uri)=>{
        if(!window.localStorage.getItem('key') || window.localStorage.getItem('key') === null || window.localStorage.getItem('key') === ''){
            window.location.href = '/dang-nhap.html';
        }
        if(item.sku.includes('C') === true || +item.typePromotion === 3){
            window.localStorage.setItem('typepage', 'product');
            window.location.href = uri;
        }else{
            let params = {
                items: [{
                    product: item.sku,
                    type: 'item',
                    action: 'add',
                    quantity: 1,
                    promo_code: item.promoCode?? "",
                    combo_code: item.combCode ?? '',
                    uudai: item.uuDai,
                    user_referral:  window.localStorage.getItem('userReferral'),
                    id_share:   window.localStorage.getItem('idShare')
            }]
            }
            try {
                actionCart(params, window.localStorage.getItem('key')).then((response)=>{
                    if(+response.status === 200 && response.message?.length > 0){
                    localStorage.removeItem("itemsCart");
                    localStorage.setItem('itemsCart', JSON.stringify(response['message']));
                    window.localStorage.setItem('reloadCart', true);
                    toast.success('Thêm vào giỏ hàng thành công.');
                    }
                });
            } catch (err) {
            console.log(err);
            }
        }
    }
    const handleRedirect=(uri)=>{
        if(uri !== '/undefined'){
            window.location.href = uri;
        }
      }
      const [wishlist, setWishlist] = useState(false);
      const handleWishlist=(sku, isFavorite)=>{
          if(window.localStorage.getItem('key')){
              setWishlist(!wishlist);
              checkWWishlist(window.localStorage.getItem('_id'),window.localStorage.getItem('_id'),sku).then((response)=>{
                  console.log(response);
              })
  
              if(isFavorite){
                  deleteWishlist(window.localStorage.getItem('_id'),window.localStorage.getItem('_id'),sku).then((response)=>{
                      console.log(response);
                  })
              }else{
                  let param = {
                      "code": window.localStorage.getItem('_id'),
                      "user_id": window.localStorage.getItem('_id'),
                      "name": "danh-sach-yeu-thich",
                      "source": "cusapp",
                      "type": "",
                    };
                  createWishlist(param).then((response)=>{
                      if(+response.status === 200){
                         let data = {
                              "wishlist_id": window.localStorage.getItem('_id'),
                              "user_id": window.localStorage.getItem('_id'),
                              "product_id": sku,
                            };
                            addProductToWishlist(data).then((response)=>{
                              console.log(response);
                            })
                      }
                  })
              }  
          }
      }
    return( 
            <div className="box-detail" key={index}>
                <div className="col-12 img-item in-f" >
                <div className="box-img-resize">
                    <img onClick={() => handleRedirect('/'+item.linksp?.replace('/',''))} className="size-img" src={item.thumbnail.replace('/origin', '/thumb')} alt={item.name}/>
                    {/* <div className="row mgx-0">
                            <div className="col-7" onClick={() => handleRedirect('/'+item.linksp?.replace('/',''))}>
                                <img className="size-img-list-item-gift" src={item.thumbnail} alt={item.name}/>
                                {
                                +item?.price['discount'] !== +item?.price['raw'] ?(<div className="box-sale-percent"><span>{RoundFloor(100-percen)}%</span></div>):(null)
                                }
                            </div>
                            <div className="col-5">
                                <div className="item-gift">
                                    <div className="text-gift">
                                        <span>tặng</span>
                                    </div>
                                    <div className="">
                                        <img className="img-gift-mobile" src={item.thumbnail_gifts[0]} alt={item.name}/>
                                    </div>
                                </div>
                            </div>
                    </div> */}
                    <img onClick={()=>handleWishlist(item.sku, item.isFavorite)} className="img-like"  src={ wishlist || item.isFavorite ? ("/../images/web_app/ic_like_active.svg"):("https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/ic_like.png")} alt="icon"/>
                    {
                     +item?.price['discount'] !== +item?.price['raw'] ?(<div className="box-sale-percent"><span>{RoundFloor(100-percen)}%</span></div>):(null)
                    }
                    </div>

                    {
                        item.labelPromo ? (
                            <img src={item.labelPromo['imageWeb']['mobileDefault']['url']} alt="icon-chinh-hang" className="position-absolute"
                            style={item.labelPromo['position']['bottom']?({
                                width:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['width'],
                                height:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['height'],
                                left:+ item.labelPromo['position']['left'],
                                bottom:+ (+item.labelPromo['position']['bottom']),
                                zIndex:1, position:"absolute"
                        }):({
                            width:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['width'],
                            height:+item.labelPromo['imageWeb']['mobileDefault']['sizeImage']['height'],
                            left:+ item.labelPromo['position']['left'],
                            top:+ item.labelPromo['position']['top'],
                            zIndex:1, position:"absolute"
                    })
                                
                            }/>
                        ):(null)
                    }
                </div>
                <div className="col-12 box-name-item pdx-8 d-flex" onClick={() => handleRedirect('/'+item.linksp?.replace('/',''))}>
                    <span className="name-item">{
                    item?.name?.length > 50 ? ( (item?.name).substring(0, 50) +'...') :(item?.name)
                    }</span>
                </div>
                <div className="col-12 mgt-5 pdx-8">
                    <span className="price-item">
                        {
                            +item?.price['discount'] < +item?.price['raw'] ? (
                                FromatNumberVIE(item?.price['raw'])
                            ) : (FromatNumberVIE(item?.price['discount']))
                        }đ</span>
                </div>
                <div className="col-12 in-f mgt-5 mgb-5 pdx-8">
                    <div className="col-10 box-list box-item-sale-bg mgr-5">
                        <span>Mua là có Quà</span>
                    </div>
                    {/* <div className="col-2 in-f">
                        <img className="svg-addcart" onClick={()=>handleAddToCart(item, '/'+item.linksp?.replace('/',''))} src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/ic_addcart.png"/>
                    </div> */}
                </div>
            </div>
    )
}

export {ItemHotDeal, ItemProductGift, ItemProductGiftList, Item, ItemDefault, ItemHotDealLanding, ItemUsingSlide, ItemHotDealLandingUsingSlide, ItemProductGiftUsingSlide};